import Api from "./api";

class CatalogApi {
	static getRoot = (projectId) => {
		const url = `catalogs/${projectId}`;
		return Api
			.get(url)
			.then(response => {
				return response.data;
			});
	};
	
}

export default CatalogApi;